import { LocaleProvider } from 'antd';
import 'moment/locale/zh-cn';
import zhCN from 'antd/lib/locale-provider/zh_CN';

import { Router, Route, Switch } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';

import '@src/Utils';

import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';

import history from './history';

import env from './env-config';

import MyAgentStore from '@store/LoginUser/MyAgentStore';
import service from '@service/index';
import login_user_store from '@store/LoginUser/LoginUserStore';



import {
  nav_data
} from '@common/NavConfig.js';

@observer
class App extends React.Component {
  route_map () {

    let result = nav_data.map((item, index) => {
      const {children, component, authority, ...rest} = item;
      return (
        <Route
          component={() => {
            return (
              <ProtectedRoute
                {...rest}
                authority = { authority }
                component = { component }/>
            )
          }}
          {...rest}
          key={index} />
      )
    });
    return result
  }

  initAppData() {
    MyAgentStore.getMyAgent();
    login_user_store.fetchUserInfo();
    service.addHookQueue(login_user_store.fetchUserInfo);
  }

  componentWillMount() {
    // this.initAppData()
  }

  componentDidMount() {
    document.getElementById('system-loading').style.display = 'none';
    this.initAppData()
  }

  render() {
    return (
      <LocaleProvider locale={zhCN}>
        <Router history={history}>
          <React.Fragment>
            {
              env !== 'prod' && (
                <div style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  zIndex: 20,
                  fontSize: "18px",
                  backgroundColor: '#68ffff',
                  padding: '5px 15px',
                  color: '#516de6'
                }}>{env}</div>
              )
            }
            <Switch>
              {
                this.route_map()
              }
            </Switch>
          </React.Fragment>
        </Router>
      </LocaleProvider>
    )
  }
}

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js